import * as React from "react";
import * as PropTypes from "prop-types";
import { PanelPosition } from "../";
import { maskMatches } from "../utils/bitmask";
const classNames = require("classnames/bind");
const css = require("./grid.scss");
const { createElement } = React;

export interface ColProps extends React.HTMLAttributes<HTMLElement> {
  width?: number;
  primary?: number;
  secondary?: number;
  first?: boolean | PanelPosition;
  last?: boolean | PanelPosition;
  tagName?: string | React.ComponentClass<any> | React.StatelessComponent<any>;
  shrink?: boolean | PanelPosition;
  hideUntilRowHover?: boolean;
  hideUntilGridHover?: boolean;
  styles?: any;
}

export class Col extends React.PureComponent<ColProps, {}> {
  public context!: {
    panelPosition?: PanelPosition;
  };

  public static defaultProps = {
    tagName: "div",
    styles: css
  };

  public static contextTypes: React.ValidationMap<any> = {
    panelPosition: PropTypes.number
  };

  get panelPosition() {
    return typeof this.context.panelPosition !== "undefined" ? this.context.panelPosition : PanelPosition.Primary;
  }

  get className() {
    const { className, width, primary, secondary, first, last, shrink, hideUntilRowHover, hideUntilGridHover, styles } = this.props;
    const { panelPosition } = this;
    const panelPositionCols = panelPosition === PanelPosition.Primary ? primary : secondary;
    const cols = typeof panelPositionCols === "number" ? panelPositionCols : width;
    const cx = classNames.bind(styles);
    return cx(className, cols && cols > 0 ? `col-xs-${cols}` : "col-xs", {
      hidden: cols === 0,
      "first-xs": maskMatches(first!, panelPosition),
      "last-xs": maskMatches(last!, panelPosition),
      "col-shrink": maskMatches(shrink!, panelPosition),
      "hide-until-hover": hideUntilRowHover,
      "hide-col-until-grid-hover": hideUntilGridHover
    });
  }

  public render() {
    const {
      tagName,
      width,
      primary,
      secondary,
      first,
      last,
      shrink,
      hideUntilRowHover,
      hideUntilGridHover,
      styles,
      ...passthrough
    } = this.props;
    return createElement(tagName!, Object.assign({}, passthrough, { className: this.className }), this.props.children);
  }
}
